import { CONSULTATION_TYPES, BUDGET_OPTIONS } from '../../../data/constants';

export const generateAvailableDates = () => {
  const dates = [];
  const today = new Date();

  for (let i = 1; i <= 30; i++) {
    const date = new Date(today);
    date.setDate(today.getDate() + i);

    if (date.getDay() !== 0 && date.getDay() !== 6) {
      dates.push({
        date: date.toISOString().split("T")[0],
        display: date.toLocaleDateString("en-US", {
          weekday: "short",
          month: "short",
          day: "numeric",
        }),
        available: Math.random() > 0.3,
      });
    }
  }

  return dates.slice(0, 30);
};

export const formatDate = (dateString) => {
  if (!dateString) return '';
  return new Date(dateString).toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

export const formatTime = (timeString) => {
  if (!timeString) return '';
  const [hours, minutes] = timeString.split(':');
  const hour = parseInt(hours);
  const ampm = hour >= 12 ? 'PM' : 'AM';
  const displayHour = hour % 12 || 12;
  return `${displayHour}:${minutes} ${ampm}`;
};

export const getConsultationType = (type) => {
  const consultationType = CONSULTATION_TYPES.find(t => t.id === type);
  return consultationType ? consultationType.title : type;
};

export const getBudgetRange = (rangeId) => {
  const range = BUDGET_OPTIONS.find(r => r.id === rangeId);
  return range ? range.range : 'To be discussed';
};
